import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import TextFieldInlineEdit from '../../../../../../TextFieldInlineEdit';
import { issueAttributesType } from '../../../../../../../constants/proptype-validation';
import { ISSUE_ATTRIBUTE_NAMES } from '../../../../../../../constants/issue-attribute-names';
import IssueFieldInlineEdit from '../../../../../../IssueFieldInlineEdit';

const EXTERNAL_ID_MAX_LENGTH = 20;
class ReferenceInlineEdit extends PureComponent {
  render() {
    const { issue, className, styleType } = this.props;

    const unspecifiedText = T.translate('unspecifiedValue');
    const label = T.translate('new.reference');

    return (
      <TextFieldInlineEdit
        issue={issue}
        className={className}
        label={label}
        placeholder={unspecifiedText}
        attributeName={ISSUE_ATTRIBUTE_NAMES.SUB_ID}
        styleType={styleType}
        horizontalAlign={true}
        inputValidator={(value) => {
          if (value && value.length > EXTERNAL_ID_MAX_LENGTH) {
            return T.translate('new.maxCharactersValidationMessage', { limit: EXTERNAL_ID_MAX_LENGTH });
          }
          return false;
        }}
      />
    );
  }
}

ReferenceInlineEdit.displayName = 'ReferenceInlineEdit';

ReferenceInlineEdit.propTypes = {
  issue: issueAttributesType,
  className: PropTypes.string,
  styleType: PropTypes.oneOf(Object.values(IssueFieldInlineEdit.StyleTypes)),
};

export default ReferenceInlineEdit;
